module.exports = __webpack_public_path__ + "static/media/magma.82bbff57.png";